// src/utils/youtube.js — one id parser for every YouTube-backed surface.
export const getYouTubeVideoId = (url) => {
    if (!url || typeof url !== 'string') return null;
    if (/^[\w-]{11}$/.test(url.trim())) return url.trim(); // already an id
    const m = url.match(/^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|shorts\/|watch\?v=|&v=)([^#&?]*).*/);
    return m && m[2] && m[2].length === 11 ? m[2] : null;
};
